import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import activity from './modules/activity'
import getters from './getters'
import lottery from './modules/lottery'
import base from './modules/base'
import user from './modules/user'
import search from './modules/search'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    activity,
    lottery,
    base,
    user,
    search
  },
  getters
})

export default store
